'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.groupby');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _velocityAnimateShim = require('velocity-react/lib/velocity-animate-shim');

var _velocityAnimateShim2 = _interopRequireDefault(_velocityAnimateShim);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _ActiveFilters = require('./ActiveFilters');

var _ActiveFilters2 = _interopRequireDefault(_ActiveFilters);

var _EventListItem = require('./EventListItem');

var _EventListItem2 = _interopRequireDefault(_EventListItem);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Pagination = require('./Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _utils = require('../helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventList = function (_Component) {
  _inherits(EventList, _Component);

  function EventList(props) {
    _classCallCheck(this, EventList);

    var _this = _possibleConstructorReturn(this, (EventList.__proto__ || Object.getPrototypeOf(EventList)).call(this));

    _this.state = {
      showPrevButton: false,
      showNextButton: true
    };

    _moment2.default.locale(props.locale);
    _this.setEventsRef = _this.setEventsRef.bind(_this);
    _this.scrollRight = _this.scroll.bind(_this, false);
    _this.scrollLeft = _this.scroll.bind(_this, true);
    return _this;
  }

  _createClass(EventList, [{
    key: 'getListItems',
    value: function getListItems(events) {
      var transferableProps = {
        dateFormat: this.props.dateFormat,
        layout: this.props.layout,
        linkDate: this.props.linkDate,
        placeholderImage: this.props.placeholderImage,
        size: this.props.size
      };

      if (this.props.template) {
        var template = this.props.template;

        return events.map(function (event) {
          return _react2.default.createElement(
            _EventListItem2.default,
            _extends({ key: event.id + '-' + (0, _moment2.default)(event.next_date || event.start_date).format('YYYYMMDD'), event: event }, transferableProps),
            _react2.default.createElement(
              'div',
              null,
              template(event)
            )
          );
        });
      }

      return events.map(function (event) {
        return _react2.default.createElement(_EventListItem2.default, _extends({ key: event.id + '-' + (0, _moment2.default)(event.next_date || event.start_date).format('YYYYMMDD'), event: event }, transferableProps));
      });
    }
  }, {
    key: 'eventList',
    value: function eventList() {
      var _this2 = this;

      var _props = this.props,
          currentPage = _props.currentPage,
          events = _props.events,
          pageChange = _props.pageChange,
          totalPages = _props.totalPages;

      var groupByFormat = this.props.groupBy === 'week' ? 'ggggww' : 'YYYYMMDD';
      var eventList = void 0;

      if (this.props.groupBy === 'none') {
        eventList = this.getListItems(events);
      } else {
        var sections = (0, _lodash2.default)(events, function (event) {
          return (0, _moment2.default)(event.next_date || event.start_date).format(groupByFormat);
        });

        eventList = Object.keys(sections).map(function (section) {
          var sectionDay = (0, _moment2.default)(section, groupByFormat);
          return _react2.default.createElement(
            'section',
            { key: section },
            _react2.default.createElement(
              'header',
              null,
              _react2.default.createElement(
                'time',
                { dateTime: sectionDay.format('YYYY-MM-DD') },
                _this2.props.groupBy === 'week' && (0, _i18n2.default)('weekOf') + ' ',
                sectionDay.format('Do MMMM')
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _this2.getListItems(sections[section])
            )
          );
        });
      }

      if (currentPage && totalPages > 1) {
        eventList.push(_react2.default.createElement(_Pagination2.default, { key: 'pagination', action: pageChange, currentPage: currentPage, totalPages: totalPages }));
      }

      return eventList;
    }
  }, {
    key: 'setEventsRef',
    value: function setEventsRef(element) {
      var _this3 = this;

      this.eventsRef = element;
      if (this.eventsRef) {
        this.eventsRef.addEventListener('scroll', function (evt) {
          var scrollMax = evt.target.scrollWidth - evt.target.offsetWidth;
          _this3.setState({
            showPrevButton: evt.target.scrollLeft > 0,
            showNextButton: evt.target.scrollLeft < scrollMax
          });
        });
      }
    }
  }, {
    key: 'scroll',
    value: function scroll(left) {
      var containerWidth = this.eventsRef.offsetWidth;
      var scrollToIndex = left ? 0 : this.eventsRef.childNodes.length - 1;
      for (var i = 0; i < this.eventsRef.childNodes.length; i += 1) {
        var el = this.eventsRef.childNodes[i];
        var wiggleRoom = el.offsetWidth * 0.1;
        var relativeX = el.offsetLeft - this.eventsRef.offsetLeft;
        var isOffscreenRight = relativeX - this.eventsRef.scrollLeft > containerWidth - wiggleRoom;
        var isOffscreenLeft = this.eventsRef.scrollLeft - relativeX < containerWidth + wiggleRoom;
        if (!left && isOffscreenRight || left && isOffscreenLeft) {
          scrollToIndex = i;
          break;
        }
      }
      (0, _velocityAnimateShim2.default)(this.eventsRef.childNodes[scrollToIndex], 'scroll', {
        axis: 'x',
        duration: 500,
        container: this.eventsRef
      }, [250, 15]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          beforeFilters = _props2.beforeFilters,
          beforeEvents = _props2.beforeEvents,
          className = _props2.className,
          clearFilters = _props2.clearFilters,
          emptyMessage = _props2.emptyMessage,
          events = _props2.events,
          filters = _props2.filters,
          removeFilter = _props2.removeFilter,
          title = _props2.title;


      var classes = (0, _utils.classNames)('EventList', className, (_classNames = {}, _defineProperty(_classNames, 'columns-' + this.props.columns + ' container-' + this.props.container, this.props.layout === 'grid' || this.props.layout === 'carousel'), _defineProperty(_classNames, 'loading', this.props.loading), _defineProperty(_classNames, 'carousel', this.props.layout === 'carousel'), _classNames));
      var hasEvents = events && events.length > 0;

      return _react2.default.createElement(
        'div',
        { className: classes },
        title && _react2.default.createElement(
          'h2',
          null,
          title
        ),
        beforeFilters,
        _react2.default.createElement(_ActiveFilters2.default, { key: 'filters', selected: filters, action: removeFilter, clear: clearFilters }),
        beforeEvents,
        hasEvents ? _react2.default.createElement(
          'div',
          { className: 'events', ref: this.setEventsRef },
          this.eventList()
        ) : _react2.default.createElement(
          'p',
          { className: 'empty' },
          emptyMessage
        ),
        hasEvents && this.props.layout === 'carousel' && _react2.default.createElement(
          'nav',
          null,
          this.state.showPrevButton && _react2.default.createElement(_Button2.default, { className: 'prev', action: this.scrollLeft, title: 'D\xE9filer le carousel vers la gauche', iconLeft: 'chevronLeft', hideTitle: true }),
          this.state.showNextButton && _react2.default.createElement(_Button2.default, { className: 'next', action: this.scrollRight, title: 'D\xE9filer le carousel vers la droite', iconLeft: 'chevronRight', hideTitle: true })
        )
      );
    }
  }]);

  return EventList;
}(_react.Component);

EventList.propTypes = {
  /** Content to be appended before ActiveFilters */
  beforeFilters: _propTypes2.default.element,
  /** Content to be appended before the event list */
  beforeEvents: _propTypes2.default.element,
  /** A CSS class to be appended to the default list of classes */
  className: _propTypes2.default.string,
  /** Function to call when all filters are cleared */
  clearFilters: _propTypes2.default.func,
  /** Number of grid columns when using the `grid` layout. */
  columns: _propTypes2.default.number,
  /** Total number of columns in the container when using the `grid` layout. */
  container: _propTypes2.default.number,
  /** Current page number */
  currentPage: _propTypes2.default.number,
  /** Method used to display the date and time. */
  dateFormat: _propTypes2.default.func,
  /** The message to display when there are no events. */
  emptyMessage: _propTypes2.default.string,
  /** Array of event objects in the Caligram API format. */
  events: _propTypes2.default.array,
  /** Currently active filters. */
  filters: _propTypes2.default.array,
  /** Groups events into `&lt;section&gt;`s based on event dates. */
  groupBy: _propTypes2.default.oneOf(['week', 'day', 'none']),
  /** Display events in a linear list, as a grid, or as a scrolling carousel. */
  layout: _propTypes2.default.oneOf(['list', 'grid', 'carousel']),
  /** Date property to use for link generation. */
  linkDate: _propTypes2.default.string,
  /** Whether the events are currently loading */
  loading: _propTypes2.default.bool,
  /** [Moment](https://momentjs.com/docs/#/i18n/) locale string */
  locale: _propTypes2.default.string,
  /** Function to call when changing page. */
  pageChange: _propTypes2.default.func,
  /** Placeholder image to be used when the event has no image. */
  placeholderImage: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  /** Function to call when a filter is removed */
  removeFilter: _propTypes2.default.func,
  /** Template for children events. A method that takes an event and returns React elements */
  template: _propTypes2.default.func,
  /** Display size of the events. Only used for the grid layout. */
  size: _propTypes2.default.oneOf(['small', 'normal']),
  /** Optional title to display above the list */
  title: _propTypes2.default.string,
  /** Total number of pages */
  totalPages: _propTypes2.default.number
};
EventList.defaultProps = {
  beforeEvents: null,
  beforeFilters: null,
  className: null,
  clearFilters: null,
  columns: 3,
  container: 12,
  currentPage: 1,
  dateFormat: undefined,
  emptyMessage: (0, _i18n2.default)('noEvents'),
  events: null,
  filters: [],
  groupBy: 'day',
  layout: 'list',
  linkDate: undefined,
  loading: false,
  locale: _config2.default.config().locale,
  pageChange: null,
  placeholderImage: null,
  removeFilter: null,
  size: 'normal',
  template: null,
  title: null,
  totalPages: null
};
exports.default = EventList;
EventList.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'getListItems',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'events',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'eventList',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'setEventsRef',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'element',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'scroll',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'left',
      'type': null
    }],
    'returns': null
  }],
  'displayName': 'EventList',
  'props': {
    'beforeEvents': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'element'
      },
      'required': false,
      'description': 'Content to be appended before the event list'
    },
    'beforeFilters': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'element'
      },
      'required': false,
      'description': 'Content to be appended before ActiveFilters'
    },
    'className': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'A CSS class to be appended to the default list of classes'
    },
    'clearFilters': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function to call when all filters are cleared'
    },
    'columns': {
      'defaultValue': {
        'value': '3',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'Number of grid columns when using the `grid` layout.'
    },
    'container': {
      'defaultValue': {
        'value': '12',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'Total number of columns in the container when using the `grid` layout.'
    },
    'currentPage': {
      'defaultValue': {
        'value': '1',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'Current page number'
    },
    'dateFormat': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Method used to display the date and time.'
    },
    'emptyMessage': {
      'defaultValue': {
        'value': 't(\'noEvents\')',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The message to display when there are no events.'
    },
    'events': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'array'
      },
      'required': false,
      'description': 'Array of event objects in the Caligram API format.'
    },
    'filters': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'array'
      },
      'required': false,
      'description': 'Currently active filters.'
    },
    'groupBy': {
      'defaultValue': {
        'value': '\'day\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'week\'',
          'computed': false
        }, {
          'value': '\'day\'',
          'computed': false
        }, {
          'value': '\'none\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Groups events into `&lt;section&gt;`s based on event dates.'
    },
    'layout': {
      'defaultValue': {
        'value': '\'list\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'list\'',
          'computed': false
        }, {
          'value': '\'grid\'',
          'computed': false
        }, {
          'value': '\'carousel\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Display events in a linear list, as a grid, or as a scrolling carousel.'
    },
    'linkDate': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Date property to use for link generation.'
    },
    'loading': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the events are currently loading'
    },
    'locale': {
      'defaultValue': {
        'value': 'CaligramReact.config().locale',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '[Moment](https://momentjs.com/docs/#/i18n/) locale string'
    },
    'pageChange': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function to call when changing page.'
    },
    'placeholderImage': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'object'
        }]
      },
      'required': false,
      'description': 'Placeholder image to be used when the event has no image.'
    },
    'removeFilter': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function to call when a filter is removed'
    },
    'size': {
      'defaultValue': {
        'value': '\'normal\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'small\'',
          'computed': false
        }, {
          'value': '\'normal\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Display size of the events. Only used for the grid layout.'
    },
    'template': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Template for children events. A method that takes an event and returns React elements'
    },
    'title': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Optional title to display above the list'
    },
    'totalPages': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'Total number of pages'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventList.js
// module id = 270
// module chunks = 0